import axios from 'axios';


/**
 * ⚠️ `VITE_API_URL` ORIGIN taşır, `/api/v1` İÇERMEZ — beş uygulamada da aynı
 * anlam (bkz. CLAUDE.md). Değer DERLEME ANINDA gömülüyor:
 * `VITE_API_URL=... npm run build`. Adres sabit yazıldığı sürece API başka
 * bir portta dinlerken landing ona yönlendirilemiyordu.
 */
const apiMainBaseUrl =
  import.meta.env?.VITE_API_URL ||
  (import.meta.env?.DEV ? "http://127.0.0.1:6380" : "https://api.cafeotomasyonu.com");
const API_BASE_URL = `${apiMainBaseUrl}/api/v1`;


const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Demo request API
export const submitDemoRequest = async (formData) => {
    try {
        const response = await api.post('/public/demo-request', formData);
        return response.data;
    } catch (error) {
        console.error('Demo request error:', error);
        throw error;
    }
};

// Contact form API
export const submitContactForm = async (formData) => {
    try {
        const response = await api.post('/public/contact-form', formData);
        return response.data;
    } catch (error) {
        console.error('Contact form error:', error);
        throw error;
    }
};

// Franchise application API
export const submitFranchiseApplication = async (formData) => {
  try {
    const response = await api.post('/public/submit-franchise-form', formData);
    return response.data;
  } catch (error) {
    console.error('Franchise application error:', error);
    throw error;
  }
};

/**
 * Modül kataloğu — fiyat vitrininin kaynağı.
 *
 * Kimlik istemiyor; yalnızca satışa AÇIK modülleri ve ticari alanları
 * döndürüyor. Hata yukarı fırlıyor: çağıran taraf pakete gömülü fiyatlarla
 * devam ediyor (bkz. `src/data/useModuleCatalog.js`).
 */
export const fetchModuleCatalog = async () => {
  const response = await api.get('/public/module-catalog');
  return response.data?.results || [];
};

export default api; 